<template>
<div style="background-color:#eee;height:100%" >

    <!-- progress days -->

    <div style="display:flex;align-items:center;width:100%" v-if="definition.type == 'pd'" :class="controlClass" class="progress-control padded">
        <div style=""><v-icon dark style="font-size:45px">check_circle</v-icon></div>
        <div class="no-wrap" style="text-align:center;flex-grow:1">{{dateInWords || 'Waiting'}}</div>
    </div>

    <!-- progress contact -->

    <div style="display:flex;height:100%;align-items:center" v-if="definition.type == 'pc'" :class="controlClass" class="progress-control contact">
        <ImageGroup style="margin-left:20px;margin-top:5px;flex-basis:70px" :images="clientImages" />
        <div style="font-size:16px;padding:15px" class="no-wrap">{{clientNames || '&nbsp;'}}</div>
    </div>
</div>
</template>

<script>
import DataHelpers from '../../helpers/DataHelpers'
import StringHelpers from '../../helpers/StringHelpers'
import NiceData from '../../data/NiceData'
import Utilities from '../../helpers/Utilities';
import ContactHelpers from '../../helpers/ContactHelpers'
import ImageGroup from '../../ui-elements/ImageGroup'
import DateHelpers from '../../helpers/DateHelpers';
import { subMonths } from 'date-fns/esm/fp'
    export default {
    name: 'ChartControl',
    props: {
        definition: Object,
        record: Object,
    },
    components: {ImageGroup},
    data() {
    return {
        transactions: []
    }
    },
    computed:{
        controlClass() {
            let value = this.record[this.definition.name]
            return {
                'green darken-1': (value === true),
                'white--text': (this.definition.type == 'pd'),
                
            }   
        }, 
        dateInWords() {
            const value = this.record[this.definition.name + '_date']
            if(!value)
                return ''
            const dateValue = DateHelpers.backwardsToDate(value)
            return DateHelpers.fromNow(dateValue)
        },

        clientNames() {
            const clientsObj = this.record['clients']
            const clients = Utilities.objectToObjectArray(clientsObj)
            const names = ContactHelpers.combineClientsNames(clients) 
            return names
        },

        clientImages() {
            const clientsObj = this.record['clients']
            const clients = Utilities.objectToObjectArray(clientsObj)
            const images = clients.map(o => o.image)
            return images
        }

    },
    methods: {
        

    },
    created() {
        // const threeMonthsAgo = subMonths(3, new Date())
        // const threeMonthsAgoStr = DateHelpers.dateToBackwards(threeMonthsAgo)
        // let ref = DataHelpers.getTenantRef(this.tenantKey).child('milestones').orderByChild('updated').startAt(threeMonthsAgoStr)
        // debugger
        // ref.on('value', snap => {
        //     const transactions = NiceData.arrayFromSnapshot(snap)
        //     this.transactions = transactions
        // })
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  
    .progress-control {
        text-align:center;
        height:100%;
        color:#555;
    }
    .padded {
        padding:8px;
    }
    .contact:hover {
        background-color: #e8e8e8;
    }
</style>


// WEBPACK FOOTER //
// ChartControl.vue?16e32f1e